import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  ViewChild,
} from '@angular/core';
import { TrustBox } from '@common/util-models';
import {
  TrustPilotManager,
  TRUST_PILOT_MANAGER,
} from '@common/util-foundation';
import { TrustboxService } from './trustbox.service';

@Component({
  selector: 'sales-trustbox',
  templateUrl: './trustbox.component.html',
  styleUrls: ['./trustbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TrustboxService],
})
export class TrustboxComponent implements AfterViewInit {
  @ViewChild('microRef', { static: false }) microRef: ElementRef | undefined;
  @ViewChild('sliderRef', { static: false }) sliderRef: ElementRef | undefined;
  TrustBox = TrustBox;
  type: TrustBox = TrustBox.MICRO;
  templateId = '';
  businessUnitId = '';

  constructor(
    @Inject(TRUST_PILOT_MANAGER) private trustPilot: TrustPilotManager,
    private trustBoxFacade: TrustboxService
  ) {}

  @Input() set trustBoxType(type: TrustBox) {
    if (type) {
      this.type = type;
      this.businessUnitId = this.trustBoxFacade.getBusinessId();
      this.templateId = this.trustBoxFacade.getTemplateIdByType(type);
    }
  }

  ngAfterViewInit() {
    const trustboxRef =
      this.type === TrustBox.MICRO
        ? this.microRef?.nativeElement
        : this.sliderRef?.nativeElement;
    this.trustPilot.loadFromElement(trustboxRef);
  }
}
